// Zeroomile brand mark — infinity loop flowing into a location pin with a green beacon dot.
export const LogoMark = ({ className = "", size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 110 96"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    {/* pin tail */}
    <path d="M56 49 L69 90 L82 49 Z" fill="currentColor" />
    {/* infinity + pin head outline */}
    <path
      d="M52 34 C52 15 26 15 26 34 C26 53 52 53 52 34 C52 15 86 15 86 34 C86 53 52 53 52 34 Z"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinejoin="round"
      fill="none"
    />
    {/* green beacon */}
    <circle cx="69" cy="34" r="12" fill="#32B432" />
  </svg>
);

export const Logo = ({ className = "", markSize = 30, textClass = "text-2xl" }) => (
  <span className={"flex items-center gap-2.5 text-brand-bone " + className}>
    <LogoMark size={markSize} />
    <span className={"font-body font-semibold tracking-tight leading-none " + textClass}>
      Zeroo<span className="text-brand-volt">&#8734;</span>Mile
    </span>
  </span>
);
